export enum LockerIntegration {
  spike = 'spike',
  spike_v2 = 'spike_v2',
}

export enum LockerCellActions {
  disable = 0,
  accessible = 1,
  connector = 2,
  id = 3,
  restrict = 4,
  unlock = 5,
}

export const SCREEN_ORIENTATIONS = ['normal', 'right', 'inverted', 'left'];

export interface IScreenTypePreset {
  orientation: string;
  resolution: string;
}

// future screen types can be added here without touching the rest of the components
export const SCREEN_TYPE_PRESETS: Record<string, IScreenTypePreset> = {
  big: {orientation: 'right', resolution: '1920x1080'},
  small: {orientation: 'normal', resolution: '1280x800'},
};
